import { useState } from 'react';
import { Mail } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { ActivityTab } from '@/components/admin/notification-management/ActivityTab';
import { MY_EMAIL_NOTIFICATION_CATEGORIES } from '../../../supabase/functions/_shared/my-email-notifications-catalog';
import '@/components/admin/notification-management/notification-management.css';

/**
 * Tools → My Email Notifications.
 *
 * The user-side view of notification emails sent on loans the user is on the loan team for,
 * one category per tab (Google Reviews first). It is the admin Activity tab in `mine` scope:
 * the same table, stored-email viewer, CSV export and inline Resend, served by the
 * `my_*` actions of `notification-activity`, which scope rows to the caller's loans.
 * Categories come from the shared catalog, so a new one is a catalog entry.
 */
export function MyEmailNotifications() {
  const categories = MY_EMAIL_NOTIFICATION_CATEGORIES;
  const [categoryId, setCategoryId] = useState<string>(categories[0]?.id ?? '');

  return (
    <div className="space-y-6" data-testid="my-email-notifications">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-foreground flex items-center gap-2">
            <Mail className="h-6 w-6 text-primary" aria-hidden="true" />
            My Email Notifications
          </h1>
          <p className="mt-1 text-sm text-muted-foreground">
            Emails sent on loans where you&apos;re on the loan team.
          </p>
        </div>
      </div>

      <Tabs value={categoryId} onValueChange={setCategoryId}>
        <TabsList aria-label="Notification categories">
          {categories.map((category) => (
            <TabsTrigger key={category.id} value={category.id}>{category.label}</TabsTrigger>
          ))}
        </TabsList>
        {categories.map((category) => (
          <TabsContent key={category.id} value={category.id} className="mt-4">
            <div className="en-theme">
              <ActivityTab scope="mine" categoryId={category.id} />
            </div>
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
}

export default MyEmailNotifications;
